<template>
  <div>
    <v-card cols="12">
      <v-row>
        <v-col>
          <div class="pa-6">
            <div>
              <v-text-field
                v-model="search"
                class="mb-2"
                append-icon="mdi-magnify"
                :label="$t('search')"
                single-line
                hide-details
                dense
                solo-inverted
                clearable
              ></v-text-field>
              <v-data-table
                :items="players"
                :headers="headers"
                :loading="loading"
                :loading-text="loadingText"
                :search="search"
                :no-data-text="$t('autoCompleteNoData')"
                :footer-props="{
                  'items-per-page-text': this.$t('rowsPerPage'),
                }"
              >
                <template v-slot:item.id="{ item }">
                  <v-btn @click="$copy(item.id)" x-small>
                    {{ item.id }}
                  </v-btn>
                </template>
                <template v-slot:item.cadatro_validado="{ item }">
                  <v-chip
                    outlined
                    :color="getVerificationStatusColor(item.cadatro_validado)"
                  >
                    {{ getVerificationStatusName(item.cadatro_validado) }}
                  </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                  <DocumentVerificationDialog
                    :userId="item.id"
                    @refreshPlayers="fetchPlayers"
                  />
                </template>
              </v-data-table>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
import DocumentVerificationDialog from "@/components/common/documentVerification";

export default {
  components: { DocumentVerificationDialog },
  data: () => ({
    players: [],
    loading: true,
    showChart: false,
    search: "",
  }),

  created() {
    this.fetchPlayers();
  },

  computed: {
    loadingText() {
      return this.$t("loadingPlayers");
    },
    headers() {
      return [
        { text: "ID", value: "id" },
        { text: this.$t("status"), value: "cadatro_validado" },
        { text: "Login", value: "login" },
        { text: this.$t("name"), value: "nome" },
        { text: "CPF", value: "cpf" },
        {
          text: this.$t("actions"),
          value: "actions",
        },
      ];
    },
  },

  methods: {
    fetchPlayers() {
      this.loading = true;

      this.$axios
        .get("/colab/players/listInvalidatedPlayers")
        .then((res) => {
          this.players = res.data.dados;
        })
        .catch(() => {
          this.players = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    getVerificationStatusName(status) {
      const map = {
        1: this.$t("pending"),
        2: this.$t("documentInAnalysis"),
        3: this.$t("concluded"),
        4: this.$t("verificationDenied"),
      };

      return map[status];
    },

    getVerificationStatusColor(status) {
      const map = {
        1: "#F64B20",
        2: "#FFEB3B",
        3: "#4CAF50",
        4: "#FF2929",
      };

      return map[status];
    },
  },
};
</script>
